import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import API_MASTER_DATA from '../../../api/apiMasterData';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_SHIFT_UPDATE } from '../../../constants/menuPermissionConstant';

class ShiftEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shiftDetail: {},
            shiftName: '',
            shiftDescription: '',
            shiftWorkStart: '',
            shiftWorkEnd: '',
            shiftBreakStart: '',
            shiftBreakEnd: '',
            showWarningShiftName: '',
            showWarningShiftDescription: '',
            showWarningShiftWorkStart: '',
            showWarningShiftWorkEnd: '',
            showWarningShiftBreakStart: '',
            showWarningShiftBreakEnd: '',
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getDetailShift = () => {
        API_MASTER_DATA.getDetailShift(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    const shiftDetail = getContent(res);
                    this.setState({
                        shiftDetail,
                        shiftName: shiftDetail.shift_name,
                        shiftDescription: shiftDetail.shift_description,
                        shiftWorkStart: shiftDetail.work_start,
                        shiftWorkEnd: shiftDetail.work_end,
                        shiftBreakStart: shiftDetail.break_start,
                        shiftBreakEnd: shiftDetail.break_end
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    putDataEditShift = () => {
        let data = {
            id: this.state.shiftDetail.id,
            shift_name: this.state.shiftName,
            shift_description: this.state.shiftDescription,
            work_start: this.state.shiftWorkStart,
            work_end: this.state.shiftWorkEnd,
            break_start: this.state.shiftBreakStart,
            break_end: this.state.shiftBreakEnd,
            shift_id: this.state.shiftDetail.shift_id,
            created_by_user: this.state.shiftDetail.created_by_user,
            created_at: this.state.shiftDetail.created_at,
            created_by: this.state.shiftDetail.created_by,
            updated_at: this.state.shiftDetail.updated_at,
            updated_by: this.state.shiftDetail.updated_by
        }

        API_MASTER_DATA.putDataEditShift(this.props.match.params.id, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showConfirmAlert: false,
                        showSuccessAlert: true
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleRedirectDetailShift = () => {
        this.props.history.goBack();
    }

    handleEditShift = () => {
        // Jika ada field yang kosong
        if (!this.state.shiftName) this.setState({ showWarningShiftName: true });
        if (!this.state.shiftDescription) this.setState({ showWarningShiftDescription: true });
        if (!this.state.shiftWorkStart) this.setState({ showWarningShiftWorkStart: true });
        if (!this.state.shiftWorkEnd) this.setState({ showWarningShiftWorkEnd: true });
        if (!this.state.shiftBreakStart) this.setState({ showWarningShiftBreakStart: true });
        if (!this.state.shiftBreakEnd) this.setState({ showWarningShiftBreakEnd: true });

        // Jika tidak ada field yang kosong
        if (this.state.shiftName && this.state.shiftDescription && this.state.shiftWorkStart && this.state.shiftWorkEnd && this.state.shiftBreakStart && this.state.shiftBreakEnd) {
            this.setState({ showConfirmAlert: true });
        }
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailShift();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_UPDATE]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Shift"
                        title="Ubah Shift"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-ticket bg-white border border-gray-300 rounded-lg flex px-6 py-10 overflow-auto">
                            <div className="w-1/2 space-y-6">
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Nama Shift <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslshiftname"
                                        className="form-control"
                                        placeholder="Tulis Nama Shift"
                                        name="shiftName"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftName: false });
                                        }}
                                        value={this.state.shiftName}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftName && <MandatoryAlert text="Nama Shift tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslshiftdescription"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi"
                                        name="shiftDescription"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftDescription: false });
                                        }}
                                        value={this.state.shiftDescription}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftDescription && <MandatoryAlert text="Deskripsi tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Mulai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkstart"
                                        className="form-control"
                                        placeholder="Tulis Jam Mulai"
                                        name="shiftWorkStart"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftWorkStart: false });
                                        }}
                                        value={this.state.shiftWorkStart}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftWorkStart && <MandatoryAlert text="Jam Mulai tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Selesai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkend"
                                        className="form-control"
                                        placeholder="Tulis Jam Selesai"
                                        name="shiftWorkEnd"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftWorkEnd: false });
                                        }}
                                        value={this.state.shiftWorkEnd}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftWorkEnd && <MandatoryAlert text="Jam Selesai tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Istirahat Mulai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkstart"
                                        className="form-control"
                                        placeholder="Tulis Jam Istirahat Mulai"
                                        name="shiftBreakStart"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftBreakStart: false });
                                        }}
                                        value={this.state.shiftBreakStart}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftBreakStart && <MandatoryAlert text="Jam Istirahat Mulai tidak boleh kosong!" />}
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Jam Istirahat Selesai <Mandatory /></p>
                                    <input
                                        type="time"
                                        id="tslworkend"
                                        className="form-control"
                                        placeholder="Tulis Jam Istirahat Selesai"
                                        name="shiftBreakEnd"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningShiftBreakEnd: false });
                                        }}
                                        value={this.state.shiftBreakEnd}
                                        autoComplete="off"
                                    />
                                    {this.state.showWarningShiftBreakEnd && <MandatoryAlert text="Jam Istirahat Selesai tidak boleh kosong!" />}
                                </div>
                            </div>
                            <div className="w-1/2 space-y-6">
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Tanggal Pembuatan</p>
                                    <input
                                        type="text"
                                        id="tslcreatedat"
                                        className="form-control"
                                        value={this.state.shiftDetail.created_at ? moment.utc(this.state.shiftDetail.created_at).format('DD/MM/YYYY | HH:mm') : '-'}
                                        disabled
                                    />
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Dibuat Oleh</p>
                                    <input
                                        type="text"
                                        id="tslcreatedby"
                                        className="form-control"
                                        value={this.state.shiftDetail.created_by_user ? this.state.shiftDetail.created_by_user : '-'}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Action Button */}
                        <div className="flex flex-row-reverse">
                            <div className="space-x-3 pt-3">
                                <ButtonBorderNexcareDefault onClick={() => this.handleRedirectDetailShift()}>
                                    Batal
                                </ButtonBorderNexcareDefault>
                                <ButtonNexcareDefault onClick={() => this.handleEditShift()}>
                                    Ubah
                                </ButtonNexcareDefault>
                            </div>
                        </div>
                    </div>

                    <Alert show={this.state.showConfirmAlert} button title="Ubah Shift" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.putDataEditShift()} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={() => this.handleRedirectDetailShift()} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftEdit);